export default __webpack_public_path__ + "atomic/_patterns/03-organisms/ct-leaderboard/_ct-leaderboard.twig";